const ForkliftCard = ({ product }) => {
  if (!product) {
    return <div>Нет данных</div>;
  }

  const specs = product.info?.reduce((acc, item) => {
    acc[item.title] = item.description;
    return acc;
  }, {}) || {};

  const imageUrl = product.img && product.img ?  process.env.REACT_APP_API_URL + 'static/' + product.img
    : 'https://placehold.co/600x400';

  return (
    <div className="product-card">
      <div className="product-gallery">
        <div className="product-image">
          <img
            src={imageUrl}
            alt={product.name}
            onError={(e) => (e.target.src = 'https://placehold.co/600x400')}
          />
        </div>
      </div>

      <div className="product-info">
        <h1 className="product-title">{product.name}</h1>

        <div className="price-section">
          <span className="price-label">Цена:</span>
          <span className="price-value">{product.price} ₽ c НДС</span>
        </div>

        <div className="specifications">
          <h2>Характеристики</h2>
          <ul className="spec-list">
            {Object.entries(specs).map(([key, value], index) => (
              <li key={index} className="spec-item">
                <span className="spec-key">{key}:</span>
                <span className="spec-value">{value}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="description">
          <h2>Описание</h2>
          <p className="description-text">{product.description || 'Описание отсутствует'}</p>
        </div>

        <div className="contact-section">
          <button className="btn btn-primary contact-button">
            <a href="tel:+79122652545">Связаться с нами</a>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForkliftCard;